var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDodatafound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 298,
    viewBox: "0 0 374 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.089 108.224C195.974 108.362 172.501 107.286 150.544 101.19C128.587 95.0942 109.168 83.5917 91.5149 70.1587C79.9575 61.4148 69.4479 54.4637 54.4423 55.5115C39.7704 56.2827 25.7367 61.7566 14.4182 71.1236C-4.66945 87.8395 -1.7735 118.733 5.83962 140.469C17.3142 173.211 52.2352 195.94 81.8879 210.752C116.174 227.881 153.826 237.839 191.588 243.549C224.689 248.569 267.195 252.238 295.855 230.612C322.197 210.78 329.424 165.432 322.969 134.814C321.397 125.771 316.584 117.611 309.426 111.865C290.917 98.3486 263.334 107.369 242.536 107.837C234.95 108.004 226.978 108.197 219.089 108.224Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.383 1.17224V13.0332",
    stroke: "#CFCFCF",
    strokeWidth: 2.34459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.453 7.10254H112.314",
    stroke: "#CFCFCF",
    strokeWidth: 2.34459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M331.41 237.592V249.453",
    stroke: "#CFCFCF",
    strokeWidth: 2.34459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M325.48 243.522H337.341",
    stroke: "#CFCFCF",
    strokeWidth: 2.34459,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7619 186.369C18.2548 186.369 19.4652 185.158 19.4652 183.666C19.4652 182.173 18.2548 180.962 16.7619 180.962C15.269 180.962 14.0586 182.173 14.0586 183.666C14.0586 185.158 15.2684 186.369 16.7619 186.369Z",
    fill: "#CFCFCF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M246.922 13.4196C248.414 13.4196 249.625 12.2093 249.625 10.7163C249.625 9.22343 248.414 8.01306 246.922 8.01306C245.43 8.01306 244.219 9.22343 244.219 10.7163C244.219 12.2087 245.43 13.4196 246.922 13.4196Z",
    fill: "#CFCFCF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.005 297.172C227.914 297.172 273.237 294.356 273.237 290.883C273.237 287.41 227.915 284.594 172.005 284.594C116.096 284.594 70.7734 287.41 70.7734 290.883C70.7734 294.356 116.096 297.172 172.005 297.172Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0261 33.39H241.047C244.704 33.39 248.213 34.8431 250.8 37.4296C253.384 40.0161 254.838 43.524 254.838 47.182V222.09C254.838 225.748 253.384 229.256 250.8 231.843C248.212 234.428 244.704 235.881 241.047 235.881H75.1865C71.5285 235.881 68.0206 234.428 65.4341 231.843C62.8476 229.256 61.3945 225.748 61.3945 222.09V66.3526L94.0261 33.39Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 2.75834,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M254.177 118.623H102.578V237.564H254.177V118.623Z",
    fill: "#D2D2D2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3945 66.3525H88.1233C89.6916 66.3455 91.1926 65.7175 92.2991 64.6061C93.4056 63.4942 94.0266 61.9906 94.0266 60.4223V33.3905L61.3945 66.3525Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 2.75834,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M253.431 80.6407H103.486C97.652 80.6407 92.9219 85.3708 92.9219 91.2052V123.285C92.9219 129.12 97.652 133.85 103.486 133.85H253.431C259.265 133.85 263.995 129.12 263.995 123.285V91.2052C263.996 85.3708 259.265 80.6407 253.431 80.6407Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 2.75834,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.053 116.527C127.141 116.527 131.266 112.403 131.266 107.314C131.266 102.226 127.141 98.101 122.053 98.101C116.964 98.101 112.84 102.226 112.84 107.314C112.84 112.403 116.964 116.527 122.053 116.527Z",
    fill: "#D2D2D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.014 116.527C156.102 116.527 160.227 112.403 160.227 107.314C160.227 102.226 156.102 98.101 151.014 98.101C145.925 98.101 141.801 102.226 141.801 107.314C141.801 112.403 145.925 116.527 151.014 116.527Z",
    fill: "#D2D2D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M179.948 116.527C185.035 116.527 189.161 112.403 189.161 107.314C189.161 102.226 185.036 98.101 179.948 98.101C174.859 98.101 170.734 102.226 170.734 107.314C170.734 112.403 174.86 116.527 179.948 116.527Z",
    fill: "#D2D2D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M253.431 139.615H103.486C97.652 139.615 92.9219 144.344 92.9219 150.179V182.259C92.9219 188.094 97.652 192.824 103.486 192.824H253.431C259.265 192.824 263.995 188.094 263.995 182.259V150.179C263.996 144.344 259.265 139.615 253.431 139.615Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 2.75834,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.053 175.528C127.141 175.528 131.266 171.404 131.266 166.315C131.266 161.227 127.141 157.102 122.053 157.102C116.964 157.102 112.84 161.227 112.84 166.315C112.84 171.403 116.964 175.528 122.053 175.528Z",
    fill: "#D2D2D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.014 175.528C156.102 175.528 160.227 171.404 160.227 166.315C160.227 161.227 156.102 157.102 151.014 157.102C145.925 157.102 141.801 161.227 141.801 166.315C141.801 171.403 145.925 175.528 151.014 175.528Z",
    fill: "#D2D2D2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M179.948 175.528C185.035 175.528 189.161 171.404 189.161 166.315C189.161 161.227 185.036 157.102 179.948 157.102C174.859 157.102 170.734 161.227 170.734 166.315C170.735 171.403 174.86 175.528 179.948 175.528Z",
    fill: "#D2D2D2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M253.431 198.616H103.486C97.652 198.616 92.9219 203.346 92.9219 209.181V241.261C92.9219 247.094 97.652 251.825 103.486 251.825H253.431C259.265 251.825 263.995 247.094 263.995 241.261V209.181C263.996 203.346 259.265 198.616 253.431 198.616Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 2.75834,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M122.053 234.502C127.141 234.502 131.266 230.379 131.266 225.289C131.266 220.201 127.141 216.076 122.053 216.076C116.964 216.076 112.84 220.2 112.84 225.289C112.84 230.379 116.964 234.502 122.053 234.502Z",
    fill: "#D2D2D2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M151.014 234.502C156.102 234.502 160.227 230.379 160.227 225.289C160.227 220.201 156.102 216.076 151.014 216.076C145.925 216.076 141.801 220.2 141.801 225.289C141.801 230.379 145.925 234.502 151.014 234.502Z",
    fill: "#D2D2D2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M179.948 234.502C185.035 234.502 189.161 230.379 189.161 225.289C189.161 220.201 185.036 216.076 179.948 216.076C174.859 216.076 170.734 220.2 170.734 225.289C170.735 230.379 174.86 234.502 179.948 234.502Z",
    fill: "#D2D2D2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M267.005 147.834C298.585 147.834 324.186 122.234 324.186 90.6536C324.186 59.0737 298.585 33.4729 267.005 33.4729C235.424 33.4729 209.824 59.0737 209.824 90.6536C209.824 122.234 235.424 147.834 267.005 147.834Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 2.75834,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M307.605 132.139L322.832 147.366",
    stroke: "#BABABA",
    strokeWidth: 2.75834,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M321.13 139.974L316.405 144.918C314.278 147.143 314.355 150.67 316.581 152.796L357.656 192.061C359.879 194.187 363.407 194.108 365.531 191.883L370.259 186.939C372.386 184.714 372.306 181.187 370.083 179.061L329.008 139.796C326.785 137.67 323.256 137.749 321.13 139.974Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 2.75834,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDodatafound);
export default __webpack_public_path__ + "static/media/dodatafound.6e426a6b8896eecae78f28c4df893a49.svg";
export { ForwardRef as ReactComponent };